"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";

export function useCompactRelativeTime() {
  const t = useTranslations("common.relativeTime");
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = window.setInterval(() => setNow(Date.now()), 60_000);
    return () => window.clearInterval(interval);
  }, []);

  return (value: string | null | undefined): string | null => {
    const timestamp = Date.parse(value ?? "");
    if (!Number.isFinite(timestamp)) return null;

    const minutes = Math.max(0, Math.floor((now - timestamp) / 60_000));
    if (minutes < 1) return t("now");
    if (minutes < 60) return t("minutes", { count: minutes });
    if (minutes < 1_440) return t("hours", { count: Math.floor(minutes / 60) });
    return t("days", { count: Math.floor(minutes / 1_440) });
  };
}
